import React from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';

const DetailTemplate = ({ children, title }) => {
  return (
    <>
      <Paper
      variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          my:2
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1,
            backgroundColor:'#424242',
            color:'#fff'
          }}
        >
          <Typography variant="subtitle1" component="div">
            {title}
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            mt: 1,
            px: 2,
            pb:2,
          }}
        >
          {children}
        </Box>
      </Paper>
    </>
  );
};

export default DetailTemplate;
